{
  "de": {
    "locale_field": {
      "fallback_tooltip": "Wenn für diese Sprache kein Text eingegeben wird, wird dieser Standardtext als Fallback verwendet.",
      "fill_missing": "Fehlende Sprache ausfüllen ({count}) | Fehlende Sprachen ausfüllen ({count})",
      "fill_missing_budget_used": "Das KI-Budget dieses Monats ist aufgebraucht.",
      "fill_missing_done": "Fehlende Sprachen ausgefüllt. Prüfen Sie den Text, bevor Sie speichern.",
      "fill_missing_errors": {
        "budget_reached": "Das KI-Budget dieses Monats ist aufgebraucht. Wenden Sie sich an Ziggu, um es zu erhöhen.",
        "generic": "Die Sprachen konnten nicht ausgefüllt werden. Versuchen Sie es erneut.",
        "too_long": "Dieser Text ist zu lang, um ihn auf einmal zu übersetzen."
      },
      "fill_missing_tooltip": "Übersetzt aus {language} mit KI. Prüfen Sie den Text, bevor Sie speichern.",
      "translated_in": "Übersetzt in"
    }
  }
}
